
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.828 17.826a2.826 2.826 0 103.999-3.998 2.826 2.826 0 10-3.999 3.998M19.01 21.01l-2.827-2.827M10.5 21H6.679c-.908 0-1.643-.895-1.643-2v-7M19 12V5c0-1.105-.735-2-1.643-2h-5.34","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5 14V8.51a3 3 0 01.879-2.122l2.509-2.51A3 3 0 0110.509 3H14","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.5 8.5h3a2 2 0 002-2v-3","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    